const charFilterRE = /[^\x20-\x39\x40-\x7E]/g

const sanitizeSearchParamKey = key => key.replace( charFilterRE, '');
const sanitizeSearchParamValue = val => val.replace( charFilterRE, '');

export {
    sanitizeSearchParamKey,
    sanitizeSearchParamValue
}